import axios from "@configs/axios";
import { useMutation } from "@tanstack/react-query";
import { queryClient } from "@configs/reactQuery";

export const updateProfile = ({ data }) => {
  var bodyFormData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (value) {
      bodyFormData.append(key, value);
    }
  });

  return axios.post(`/api/profile/`, bodyFormData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const useUpdateProfile = ({ config } = {}) => {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("profile");
    },
    ...config,
    mutationFn: updateProfile,
  });
};
